import { secondsToISO } from './seconds-to-iso';

import type { Track } from '@/types/tracks';
import type { AudioObject } from 'schema-dts';

export const getSfxSchema = (tracks: Track[] | undefined): AudioObject[] => {
  if (!tracks) {
    return [];
  }

  return tracks.map<AudioObject>((track) => {
    const duration = secondsToISO(track.track_version[0].version_length);

    return {
      '@type': 'AudioObject',
      name: track.name,
      duration,
      encodingFormat: 'audio/mpeg',
      author: track.artist
        ? {
            '@type': 'Organization',
            name: track.artist.name,
          }
        : undefined,
    };
  });
};
